import NotificationTypes from '../constants/notification';
import NotificationService from '../services/notification.service';

export const getNotificationFranchPayment = () => async dispatch => {
    try {
        const res = await NotificationService.getNotificationFranchPayment();
        dispatch({
            type: NotificationTypes.SET_NOTIFICATION_FRANCH_PAYMENT,
            payload: res,
        });
    } catch (error) {
        console.error(error);
    }
};

export const closeNotificationFranchPayment = id => async dispatch => {
    await NotificationService.markAsRead(id);
};
